<!-- src/components/InterviewPage.vue -->
<template>
  <div class="dashboard-root">
    <header class="dashboard-header-bar">
      <div class="dashboard-header-container">
        <div @click="goToHome" class="logo" style="cursor: pointer;">
          <img src="/logo.png" alt="Linkoffer Logo" class="logo-icon" width="32" height="32">
          <span>Linkoffer</span>
        </div>
        <div class="dashboard-actions">
          <div @click="goToHome" class="icon-btn home-btn" title="返回主页" style="cursor: pointer;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 12l9-8 9 8" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 21V12h6v9" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>
    </header>
    <main class="dashboard-content">
      <div class="container">
        <div class="dashboard-title-bar">
          <span class="dashboard-title">面试记录</span>
          <button class="btn btn-blue create-btn" @click="createInterview">创建面试</button>
        </div>
        <div class="dashboard-table-wrapper">
          <table class="dashboard-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>面试名称</th>
                <th>创建时间</th>
                <th>面试时长
                  <span class="help-icon">
                    <svg width="20" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    <span class="custom-tooltip">
                      如果您没有点击结束面试，则系统将在300分钟后自动结束面试
                    </span>
                  </span>
                </th>
                <th>总答题次数</th>
                <th>
                  操作
                  <span class="help-icon">
                    <svg width="20" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    <span class="custom-tooltip">
                      为了保护用户隐私，面试信息仅做浏览器本地缓存；
                      您可点击下方按钮，获取面试记录(谨慎删除缓存，否则可能无法找回面试记录）
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in interviewRecords" :key="item.interviewId">
                <td>{{ (pageNum - 1) * pageSize + idx + 1 }}</td>
                <td>{{ item.interviewName }}</td>
                <td>{{ item.createTime }}</td>
                <td>{{ item.totalMinutes }}</td>
                <td>{{ item.agTotalCount }}</td>
                <td>
                  <button class="btn btn-outline-blue btn-action" @click="downloadRecord(item)">面试记录</button>
                  <button class="btn btn-outline-blue btn-action" v-if="item.status === 1" @click="view(item)">返回面试</button>
                </td>
              </tr>
              <tr v-if="interviewRecords.length === 0">
                <td colspan="6" class="empty-tip">暂无面试记录</td>
              </tr>
            </tbody>
          </table>
          <div class="pagination-wrapper">
            <button class="btn btn-outline page-btn" :disabled="pageNum === 1" @click="prevPage">上一页</button>
            <span class="page-info">第 {{ pageNum }} 页 / 共 {{ totalPages }} 页</span>
            <button class="btn btn-outline page-btn" :disabled="pageNum === totalPages" @click="nextPage">下一页</button>
          </div>
        </div>
      </div>
    </main>





      <!-- 设置内容区域高度 -->
      <register
        :dialogRegisterVisible="dialogRegisterVisible"
        @close="dialogRegisterVisible = false"
      ></register>
    <!-- </el-dialog> -->
    <div v-show="false">
      <InterviewPrint
        ref="printRef"
        v-if="printData"
        :info="printData.info"
        :quickCount="printData.quickCount"
        :deepCount="printData.deepCount"
        :screenshotCount="printData.screenshotCount"
        :durationStr="printData.durationStr"
        :answerRows="printData.answerRows"
      />
      </div>
  </div>
</template>

<script>
import Register from '../views/CreateInterview/CreateInterviewStep1.vue';


import {useStore} from "../store";
import {interviewList, interviewInfo} from "../api/interview";
import InterviewPrint from './InterviewPrint.vue';

export default {
  components: {
    'register': Register,
    InterviewPrint
  },
  created() {
    this.store = useStore();
    this.interviewList();
  },
  data() {
    return {
      store: null, // 全局状态管理
      activeIndex: 1,
      // 注册弹窗标识
      dialogRegisterVisible: false,
      interviewRecords: [
      ],
      totalRecords: 0,
      pageSize: 20,
      pageNum: 1,
      printData: null,
      printWindow: null, // 保存打印窗口引用
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.pageSize);
    }
  },
  methods: {
    // 检测是否为移动设备
    isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      const isMobile = mobileRegex.test(userAgent.toLowerCase());
      // 同时检查屏幕宽度
      const isSmallScreen = window.innerWidth <= 768;
      return isMobile || isSmallScreen;
    },
    handleSizeChange(val) {
      console.log('每页显示:', val);
      this.pageSize = val;
      this.pageNum = 1;
      this.interviewList(); // 重新获取数据
    },

    handleCurrentChange(val) {
      console.log('当前页:', val);
      this.pageNum = val;
      this.interviewList(); // 重新获取数据
    },

    // 上一页
    prevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.interviewList();
      }
    },

    // 下一页
    nextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum++;
        this.interviewList();
      }
    },

    // 跳转首页
    goToHome() {
      this.$router.push('/home');
    },

    // 获取用户信息
    async interviewList() {
       // 准备登录信息
      const obj = {pageNum: this.pageNum, pageSize: this.pageSize};
      const response = await interviewList(obj)
      if (response.code === 200) {
         this.interviewRecords = response.data.records; 
         this.totalRecords = response.data.total;

        }
    },
    handleMenuSelect(index) {
      if (index === '1') {
        // this.$router.push('/userInfo');
       const routeUrl = this.$router.resolve({
          name: 'userInfo', // 假设 Homepage 的路由名称为 'Homepage'
          query: { activeIndex: 4 } // 通过 query 参数传递 activeIndex
        })
        window.open(routeUrl.href, '_blank')
      } else if (index === '2') {
        // 退出登录逻辑
        // 退出登录逻辑
        this.store = useStore();
        console.log('store:', this.store);
        console.log('store:', this.store.isLogin);
        this.store.isLogin = false;
        this.$router.push('/home');
        
      }
    },
    changeMenu(index) {
      this.activeIndex = index;
    },
    handleLogin() {
      this.$emit('login');
    },
    handleRegister() {
      this.$emit('register');
    },
    createInterview() {
      // 存在是否有进行中的面试，如果有，则提示用户先结束当前面试
      if(this.interviewRecords.length > 0 && this.interviewRecords.some(item => item.status === 1)) {
        this.$message.error('您有进行中的面试，请先结束当前面试');
        return;
      }
      this.dialogRegisterVisible = true;
      // 创建面试的逻辑
    },
    downloadRecord(row) {
      const isMobile = this.isMobileDevice();
      
      // 移动端特殊处理：检测是否支持 window.open
      if (isMobile) {
        // 先尝试打开窗口，如果失败则使用降级方案
        try {
          this.printWindow = window.open('', '_blank');
          if (!this.printWindow || this.printWindow.closed) {
            // 移动端降级方案：在当前页面显示内容
            this.showMobilePrintView(row);
            return;
          }
        } catch (e) {
          console.error('打开窗口失败:', e);
          this.showMobilePrintView(row);
          return;
        }
      } else {
        // 桌面端：在用户点击时立即打开窗口（必须在用户交互上下文中）
        this.printWindow = window.open('', '_blank');
        if (!this.printWindow) {
          this.$message.error('打印窗口被拦截，请允许弹窗');
          return;
        }
      }
      
      // 显示加载提示
      try {
        this.printWindow.document.write(`
          <html>
            <head>
              <title>面试记录 - 加载中...</title>
              <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
              <meta charset="utf-8"/>
              <style>
                body { 
                  display: flex; 
                  align-items: center; 
                  justify-content: center; 
                  height: 100vh; 
                  margin: 0; 
                  font-family: Arial, sans-serif;
                  background: #f5f5f5;
                }
                .loading {
                  text-align: center;
                  color: #666;
                }
              </style>
            </head>
            <body>
              <div class="loading">正在加载面试记录...</div>
            </body>
          </html>
        `);
        this.printWindow.document.close();
      } catch (e) {
        console.error('写入加载页面失败:', e);
        // 如果 document.write 失败，尝试使用 innerHTML
        try {
          if (this.printWindow && this.printWindow.document) {
            if (!this.printWindow.document.body) {
              this.printWindow.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"/></head><body></body></html>');
            }
            this.printWindow.document.body.innerHTML = '<div style="text-align:center;padding:20px;">正在加载面试记录...</div>';
          }
        } catch (e2) {
          console.error('设置加载提示失败:', e2);
        }
      }
      
      // 设置超时检测（10秒后如果还在加载，提示用户）
      const loadingTimeout = setTimeout(() => {
        if (this.printWindow && !this.printWindow.closed) {
          try {
            const bodyText = this.printWindow.document.body ? this.printWindow.document.body.innerText : '';
            if (bodyText && bodyText.includes('正在加载')) {
              console.warn('加载超时，可能浏览器不支持');
              this.$message.warning('加载时间过长，请检查浏览器设置或重试');
            }
          } catch (e) {
            console.error('检查加载状态失败:', e);
          }
        }
      }, 10000);
      
      // 然后异步获取数据并填充内容
      this.generateInterviewPrint(row).finally(() => {
        // 清除超时检测
        clearTimeout(loadingTimeout);
      });
    },
    
    // 移动端降级方案：在当前页面显示打印内容
    async showMobilePrintView(row) {
      try {
        // 获取面试信息
        const interviewId = row.interviewId;
        const infoRes = await interviewInfo(interviewId);
        if (!infoRes || infoRes.code !== 200) {
          this.$message.error('获取面试信息失败');
          return;
        }
        const info = infoRes.data || {};
        
        // 获取答题历史记录
        const answerRecords = this.store.getAnswerRecordByInterviewId(interviewId);
        
        // 统计次数
        let quickCount = 0, deepCount = 0, screenshotCount = 0;
        const answerRows = [];
        answerRecords.forEach(record => {
          const question = Object.keys(record)[0];
          const answerObj = record[question] || {};
          if (answerObj.quick) quickCount++;
          if (answerObj.deep) deepCount++;
          if (answerObj.screenshot) screenshotCount++;
          answerRows.push([
            question,
            answerObj.quick || '',
            answerObj.deep || '',
            answerObj.screenshot || ''
          ]);
        });
        
        // 格式化时长
        let durationStr = '';
        if (info.totalMinutes) {
          const min = Math.floor(info.totalMinutes);
          const sec = Math.round((info.totalMinutes - min) * 60);
          durationStr = `${min}分${sec}秒`;
        }
        
        // 设置打印数据
        this.printData = { info, quickCount, deepCount, screenshotCount, durationStr, answerRows };
        
        // 显示移动端打印视图（可以通过路由或弹窗显示）
        this.$message({
          message: '移动端浏览器限制，请使用复制功能保存内容，或使用浏览器分享功能',
          type: 'info',
          duration: 5000
        });
        
        // 可以在这里添加一个全屏弹窗显示打印内容
        // 或者直接跳转到一个新路由显示打印内容
        this.$nextTick(() => {
          const el = document.getElementById('print-area');
          if (el) {
            // 创建一个全屏遮罩显示内容
            this.showMobilePrintModal();
          }
        });
      } catch (e) {
        console.error('显示移动端打印视图失败:', e);
        this.$message.error('加载面试记录失败');
      }
    },
    
    // 显示移动端打印模态框
    showMobilePrintModal() {
      // 这里可以创建一个全屏模态框显示打印内容
      // 暂时使用提示，后续可以扩展为全屏显示
      this.$message({
        message: '请使用浏览器菜单中的"分享"或"打印"功能',
        type: 'warning',
        duration: 4000
      });
    },
    
    // 直接生成打印HTML内容（不依赖Vue组件渲染）
    generatePrintHTML(info, quickCount, deepCount, screenshotCount, durationStr, answerRows) {
      // 转义HTML特殊字符，但保留已有的HTML标签（如v-html中的内容）
      const escapeHtml = (text) => {
        if (!text) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      };
      
      // 生成答题记录表格行
      let answerRowsHTML = '';
      if (answerRows && answerRows.length > 0) {
        answerRows.forEach(row => {
          const question = escapeHtml(row[0] || '');
          const quick = row[1] || ''; // 可能包含HTML，不转义
          const deep = row[2] || ''; // 可能包含HTML，不转义
          const screenshot = row[3] || ''; // 可能包含HTML，不转义
          answerRowsHTML += `
            <tr>
              <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;">${question}</td>
              <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;">${quick}</td>
              <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;">${deep}</td>
              <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;">${screenshot}</td>
            </tr>
          `;
        });
      } else {
        answerRowsHTML = '<tr><td colspan="4" style="text-align:center; color:#aaa; padding: 16px 0;">暂无答题记录</td></tr>';
      }
      
      // 生成完整的打印内容HTML
      const printContentHTML = `
        <div id="print-area" style="padding: 32px; font-family: '微软雅黑', 'Source Han Sans', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif; color: #222; background: #fff;">
          <h2 style="text-align:center; margin-bottom: 24px; font-size: 24px; font-weight: bold;">面试记录</h2>
          <table style="width: 100%; margin-bottom: 18px; font-size: 15px; border-collapse: collapse;">
            <tbody>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold; width: 120px;">面试名称：</td>
                <td style="padding: 6px 4px;">${escapeHtml(info.interviewName || '')}</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">创建时间：</td>
                <td style="padding: 6px 4px;">${escapeHtml(info.createTime || '')}</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">面试时长：</td>
                <td style="padding: 6px 4px;">${escapeHtml(durationStr || '')}</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">总答题次数：</td>
                <td style="padding: 6px 4px;">${escapeHtml(String(info.agTotalCount || 0))}</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">快答次数：</td>
                <td style="padding: 6px 4px;">${quickCount} 次</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">深度回答次数：</td>
                <td style="padding: 6px 4px;">${deepCount} 次</td>
              </tr>
              <tr>
                <td style="padding: 6px 4px; font-weight: bold;">截图回答次数：</td>
                <td style="padding: 6px 4px;">${screenshotCount} 次</td>
              </tr>
            </tbody>
          </table>
          <hr style="margin: 18px 0; border: none; border-top: 1.5px solid #e0e0e0;">
          <h3 style="margin-bottom: 12px; font-size: 18px; font-weight: bold;">答题历史记录</h3>
          <table border="1" style="width:100%;border-collapse:collapse;font-size:14px;">
            <thead>
              <tr style="background:#f0f2f5;">
                <th style="padding:8px 4px; font-weight: bold;">问题</th>
                <th style="padding:8px 4px; font-weight: bold;">快答内容</th>
                <th style="padding:8px 4px; font-weight: bold;">深度思考内容</th>
                <th style="padding:8px 4px; font-weight: bold;">截图回答内容</th>
              </tr>
            </thead>
            <tbody>
              ${answerRowsHTML}
            </tbody>
          </table>
        </div>
      `;
      
      return printContentHTML;
    },
    async generateInterviewPrint(item) {
      try {
        // 1. 获取面试信息
        const interviewId = item.interviewId;
        let infoRes;
        try {
          infoRes = await interviewInfo(interviewId);
        } catch (e) {
          console.error('获取面试信息失败:', e);
          this.$message.error('获取面试信息失败');
          if (this.printWindow) {
            try {
              this.printWindow.close();
            } catch (closeError) {
              console.error('关闭窗口失败:', closeError);
            }
            this.printWindow = null;
          }
          return;
        }
        if (!infoRes || infoRes.code !== 200) {
          this.$message.error('获取面试信息失败');
          if (this.printWindow) {
            try {
              this.printWindow.close();
            } catch (closeError) {
              console.error('关闭窗口失败:', closeError);
            }
            this.printWindow = null;
          }
          return;
        }
        const info = infoRes.data || {};

        // 2. 获取答题历史记录
        const answerRecords = this.store.getAnswerRecordByInterviewId(interviewId);

        // 3. 统计快答/深度思考/截图回答次数
        let quickCount = 0, deepCount = 0, screenshotCount = 0;
        const answerRows = [];
        answerRecords.forEach(record => {
          const question = Object.keys(record)[0];
          const answerObj = record[question] || {};
          if (answerObj.quick) quickCount++;
          if (answerObj.deep) deepCount++;
          if (answerObj.screenshot) screenshotCount++;
          answerRows.push([
            question,
            answerObj.quick || '',
            answerObj.deep || '',
            answerObj.screenshot || ''
          ]);
        });

        // 格式化面试时长
        let durationStr = '';
        if (info.totalMinutes) {
          const min = Math.floor(info.totalMinutes);
          const sec = Math.round((info.totalMinutes - min) * 60);
          durationStr = `${min}分${sec}秒`;
        }

        // 4. 直接生成HTML内容（不依赖Vue组件渲染，提高兼容性）
        const html = this.generatePrintHTML(info, quickCount, deepCount, screenshotCount, durationStr, answerRows);
        
        // 检查窗口是否仍然打开
        if (!this.printWindow || this.printWindow.closed) {
          this.$message.error('打印窗口已关闭，请重试');
          return;
        }
        
        // 确保窗口文档已准备好
        try {
          if (!this.printWindow.document) {
            this.$message.error('打印窗口文档未准备好');
            if (this.printWindow) {
              this.printWindow.close();
              this.printWindow = null;
            }
            return;
          }
        } catch (e) {
          console.error('访问打印窗口文档失败:', e);
          this.$message.error('无法访问打印窗口，可能是浏览器安全限制');
          if (this.printWindow) {
            try {
              this.printWindow.close();
            } catch (e2) {
              console.error('关闭窗口失败:', e2);
            }
            this.printWindow = null;
          }
          return;
        }
        
        // 构建HTML字符串
        const htmlParts = [
          '<!DOCTYPE html><html><head>',
          '<title>面试记录</title>',
          '<meta name="viewport" content="width=device-width, initial-scale=1.0"/>',
          '<style>',
          '@page { size: auto; margin: 10mm; }',
          'body { ',
          'background: #fff; ',
          '-webkit-print-color-adjust: exact; ',
          'print-color-adjust: exact; ',
          'margin: 0; ',
          'padding: 20px; ',
          'font-family: "微软雅黑", "Source Han Sans", "PingFang SC", "Microsoft YaHei", Arial, sans-serif;',
          '}',
          'table { border-collapse: collapse; width: 100%; }',
          'th, td { border: 1px solid #e0e0e0; }',
          '@media print { ',
          'body { padding: 0 !important; }',
          '}',
          '</style>',
          '</head><body>',
          html,
          '</body></html>'
        ];
        
        // 写入内容到已打开的窗口
        try {
          // 尝试使用 document.write（兼容性好）
          // 先清空现有内容（如果有）
          if (this.printWindow.document.body) {
            this.printWindow.document.body.innerHTML = '';
          }
          
          this.printWindow.document.open();
          this.printWindow.document.write(htmlParts.join(''));
          this.printWindow.document.close();
          
          // 确保内容已写入（UC浏览器可能需要额外等待）
          const checkContent = () => {
            if (this.printWindow && !this.printWindow.closed && this.printWindow.document) {
              const bodyContent = this.printWindow.document.body ? this.printWindow.document.body.innerHTML : '';
              if (!bodyContent || bodyContent.includes('正在加载')) {
                // 如果内容还是加载中，重新写入
                console.log('检测到内容未正确加载，重新写入...');
                try {
                  this.printWindow.document.open();
                  this.printWindow.document.write(htmlParts.join(''));
                  this.printWindow.document.close();
                } catch (retryError) {
                  console.error('重试写入失败:', retryError);
                }
              }
            }
          };
          
          // 延迟检查，确保内容已写入
          setTimeout(checkContent, 200);
        } catch (e) {
          console.error('document.write 失败，尝试使用降级方案:', e);
          // 降级方案：重新构建完整的 HTML 文档
          try {
            if (this.printWindow && this.printWindow.document && !this.printWindow.closed) {
              // 先写入基本结构
              this.printWindow.document.open();
              this.printWindow.document.write('<!DOCTYPE html><html><head><title>面试记录</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"/></head><body></body></html>');
              this.printWindow.document.close();
              
              // 等待文档就绪后添加样式和内容
              setTimeout(() => {
                if (this.printWindow && !this.printWindow.closed && this.printWindow.document) {
                  const styleEl = this.printWindow.document.createElement('style');
                  styleEl.textContent = htmlParts.join('').match(/<style>([\s\S]*?)<\/style>/)?.[1] || '';
                  this.printWindow.document.head.appendChild(styleEl);
                  
                  this.printWindow.document.body.innerHTML = html;
                }
              }, 100);
            }
          } catch (e2) {
            console.error('降级方案也失败:', e2);
            this.$message.error('无法打开打印页面，请检查浏览器设置');
            if (this.printWindow) {
              try {
                this.printWindow.close();
              } catch (e3) {
                console.error('关闭窗口失败:', e3);
              }
              this.printWindow = null;
            }
            return;
          }
        }
        
        // 聚焦窗口，让用户自己决定是否打印
        try {
          if (this.printWindow && !this.printWindow.closed) {
            this.printWindow.focus();
          }
        } catch (e) {
          console.error('聚焦窗口失败:', e);
        }
      } catch (error) {
        console.error('generateInterviewPrint 发生错误:', error);
        this.$message.error('生成打印内容失败，请重试');
        if (this.printWindow) {
          try {
            this.printWindow.close();
          } catch (closeError) {
            console.error('关闭窗口失败:', closeError);
          }
          this.printWindow = null;
        }
      }
    },
    view(val) {
      // 清除IP缓存
      this.clearBoundClientCache();
      // 跳转到面试详情页
      this.$router.push({
        name: 'CreateInterviewStep2',
        query: { interviewId: val.interviewId }
      });
    },
    testPrint() {
      const el = document.getElementById('print-area');
      if (!el) {
        this.$message.error('打印区域未渲染');
        return;
      }
      const html = el.outerHTML;
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        this.$message.error('打印窗口被拦截，请允许弹窗');
        return;
      }
      printWindow.document.write(`
        <html>
          <head>
            <title>面试记录</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <style>
              @page { size: auto; margin: 10mm; }
              body { background: #fff; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              table { border-collapse: collapse; }
              th, td { border: 1px solid #e0e0e0; }
            </style>
          </head>
          <body>${html}</body>
        </html>
      `);
      printWindow.document.close();
      const doPrint = () => {
        try {
          printWindow.focus();
          printWindow.print();
        } finally {
          printWindow.close();
        }
      };
      if ('onload' in printWindow) {
        printWindow.onload = () => setTimeout(doPrint, 100);
      } else {
        setTimeout(doPrint, 300);
      }
    },

    clearBoundClientCache() {
      localStorage.removeItem('boundClientId');
      console.log('返回面试时IP缓存已清除');
    }
  }
};
</script>

<style scoped>
.dashboard-root {
  min-height: 100vh;
  background: #f6f8fa;
  color: #222;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  font-size: 14px;
}

.dashboard-header-bar {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.dashboard-header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 20px;
}

.logo-icon {
  height: 32px;
  width: 32px;
  margin-right: 8px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #2563eb, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.02em;
}

.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-btn {
  background: #fff;
  border: 1.5px solid #1890ff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  padding: 0;
}

.icon-btn:hover {
  background: #e6f7ff;
  border-color: #1765ad;
}

.user-btn svg, .home-btn svg {
  display: block;
  width: 20px;
  height: 20px;
}

.dashboard-content {
  padding-top: 24px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.dashboard-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.dashboard-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: #1765ad;
  letter-spacing: 0.02em;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}

.create-btn {
  background: #1890ff;
  color: #fff;
  border: none;
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(24,144,255,0.04);
  transition: background 0.3s, transform 0.2s;
  min-width: 120px;
  height: 42px;
}

.create-btn:hover {
  background: #1765ad;
  transform: translateY(-2px);
}

.dashboard-table-wrapper {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  padding: 18px 12px 8px 12px;
  margin-bottom: 32px;
}

.dashboard-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dashboard-table th, .dashboard-table td {
  padding: 10px 8px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
}

.dashboard-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #1765ad;
  font-size: 13.5px;
  letter-spacing: 0.01em;
  vertical-align: middle;
}

.dashboard-table tr:last-child td {
  border-bottom: none;
}

.btn {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  margin: 0 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-blue {
  background: #1890ff;
  color: #fff;
  border: none;
}

.btn-blue:hover {
  background: #1765ad;
}

.btn-action {
  margin: 0 6px;
}

.btn-outline {
  background: #fff;
  color: #1890ff;
  border: 1.5px solid #1890ff;
}

.btn-outline:hover {
  background: #e6f7ff;
  color: #1765ad;
  border-color: #1765ad;
}

.empty-tip {
  color: #aaa;
  font-size: 0.95rem;
  text-align: center;
  padding: 18px 0;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin: 12px 0 16px 0;
}

.page-btn {
  min-width: 70px;
}

.page-info {
  font-size: 13px;
  color: #666;
}

.btn-outline-blue {
  background: #fff;
  color: #1890ff;
  border: 1.5px solid #1890ff;
}

.btn-outline-blue:hover {
  background: #e6f7ff;
  color: #1765ad;
  border-color: #1765ad;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-info:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  border-color: #d1d5db;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-info iconify-icon {
  color: #2563eb;
}

.username {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 4px;
  min-width: 16px;
  text-align: center;
}

/* 弹窗样式 */
.popover-content {
  padding: 0;
}

.el-menu-vertical-demo {
  border: none;
  background: transparent;
}

.el-menu-item {
  border-radius: 0;
  background: transparent;
  color: #333;
  font-size: 14px;
  padding: 12px 20px;
  transition: all 0.2s ease;
}

.el-menu-item:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  color: #2563eb;
  border-radius: 0;
}

.el-menu-item i {
  margin-right: 8px;
  color: inherit;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  color: #999;
  cursor: help;
  transition: color 0.2s ease;
  vertical-align: middle;
}

.help-icon:hover {
  color: #1890ff;
}

.help-icon svg {
  width: 14px;
  height: 14px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .dashboard-header-container {
    padding: 0 16px;
  }
  
  .dashboard-content {
    padding: 20px 0;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .dashboard-title-bar {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .dashboard-title {
    font-size: 1.5rem;
  }
  
  .create-btn {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
  
  .dashboard-table-wrapper {
    overflow-x: auto;
    margin: 0 -16px;
    padding: 0 16px;
  }
  
  .dashboard-table {
    min-width: 600px;
    font-size: 12px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 8px 6px;
    white-space: nowrap;
  }
  
  .btn-action {
    padding: 6px 12px;
    font-size: 12px;
    margin: 2px;
  }
  
  .pagination-wrapper {
    flex-direction: row !important;
    gap: 12px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .page-info {
    font-size: 12px;
  }
  
  .page-btn {
    min-width: 60px;
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .logo span {
    font-size: 16px;
  }
  
  .logo-icon {
    width: 24px;
    height: 24px;
  }
  
  .home-btn {
    padding: 8px;
  }
  
  .home-btn svg {
    width: 20px;
    height: 20px;
  }
  
  .help-icon {
    margin-left: 4px;
    vertical-align: middle;
  }
  
  .help-icon svg {
    width: 12px;
    height: 12px;
  }
  
  .custom-tooltip {
    font-size: 11px;
    padding: 8px 12px;
    max-width: 200px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-header-container {
    padding: 0 24px;
  }
  
  .container {
    padding: 0 24px;
  }
  
  .dashboard-table {
    font-size: 13px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 10px 8px;
  }
  
  .btn-action {
    padding: 8px 16px;
    font-size: 13px;
  }
  
  .create-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .dashboard-header-container {
    padding: 0 12px;
  }
  
  .container {
    padding: 0 12px;
  }
  
  .dashboard-title {
    font-size: 1.3rem;
  }
  
  .dashboard-table {
    min-width: 500px;
    font-size: 11px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 6px 4px;
  }
  
  .dashboard-table th:nth-child(2),
  .dashboard-table td:nth-child(2) {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .btn-action {
    padding: 4px 8px;
    font-size: 11px;
    margin: 1px;
  }
  
  .page-btn {
    min-width: 50px;
    padding: 6px 12px;
    font-size: 11px;
  }
  
  .page-info {
    font-size: 11px;
  }
  
  .logo span {
    font-size: 14px;
  }
  
  .logo-icon {
    width: 20px;
    height: 20px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .dashboard-header-bar {
    height: 50px;
  }
  
  .dashboard-content {
    padding: 15px 0;
  }
  
  .dashboard-title-bar {
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
  
  .dashboard-title {
    font-size: 1.4rem;
  }
  
  .create-btn {
    width: auto;
    padding: 10px 20px;
    font-size: 13px;
  }
  
  .dashboard-table {
    font-size: 12px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 6px 8px;
  }
}
</style>